/* ============================================================
   MaglieMeme Theme v2 — theme.js
   AJAX cart drawer, variant selector, gallery, mobile nav,
   sticky ATC, toast notifications, search toggle
   ============================================================ */
(function () {
  'use strict';

  /* ================================================================
     UTILITIES
  ================================================================ */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  function debounce(fn, wait) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); };
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  }

  /* ================================================================
     OVERLAY
  ================================================================ */
  const overlay = $('#Overlay');
  let _openDrawers = 0;

  function showOverlay() {
    _openDrawers++;
    overlay && overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }
  function hideOverlay() {
    _openDrawers = Math.max(0, _openDrawers - 1);
    if (_openDrawers === 0) {
      overlay && overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }

  overlay && overlay.addEventListener('click', () => {
    closeCartDrawer();
    closeMobileNav();
  });

  /* ================================================================
     TOAST
  ================================================================ */
  let toastTimer;
  function showToast(msg) {
    const t = $('#Toast');
    if (!t) return;
    const textEl = t.querySelector('.toast__text');
    if (textEl) textEl.textContent = msg || 'Aggiunto al carrello!';
    t.classList.add('is-visible');
    t.removeAttribute('aria-hidden');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      t.classList.remove('is-visible');
      t.setAttribute('aria-hidden', 'true');
    }, 3000);
  }

  /* ================================================================
     CART STATE
  ================================================================ */
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
    return res.json();
  }

  function updateCartBubble(count) {
    const bubble = $('#CartBubble');
    if (!bubble) return;
    bubble.textContent = count;
    bubble.classList.toggle('is-empty', count === 0);
    // Bump animation
    bubble.classList.remove('bump');
    requestAnimationFrame(() => { bubble.classList.add('bump'); setTimeout(() => bubble.classList.remove('bump'), 400); });
  }

  /* ================================================================
     CART DRAWER
  ================================================================ */
  const cartDrawer = $('#CartDrawer');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.removeAttribute('aria-hidden');
    showOverlay();
    const closeBtn = $('#CartDrawerClose');
    closeBtn && closeBtn.focus();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    hideOverlay();
  }

  // Toggle button
  const cartToggle = $('#CartDrawerToggle');
  cartToggle && cartToggle.addEventListener('click', () => {
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCartDrawer();
    else { refreshCartDrawer(); openCartDrawer(); }
  });

  // Close button
  const cartClose = $('#CartDrawerClose');
  cartClose && cartClose.addEventListener('click', closeCartDrawer);

  // Keyboard close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeCartDrawer(); closeMobileNav(); closeSearch(); }
  });

  async function refreshCartDrawer() {
    const cart = await fetchCart();
    renderCartDrawer(cart);
  }

  function renderCartDrawer(cart) {
    const body = $('#CartDrawerBody');
    const footer = $('#CartDrawerFooter');
    const countEl = $('#CartDrawerCount');
    const subtotalEl = $('#CartDrawerSubtotal');
    const totalEl = $('#CartDrawerTotal');

    if (countEl) countEl.textContent = '(' + cart.item_count + ')';

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Discount progress bar (3 items = 20% off)
    const DISCOUNT_THRESHOLD = 3;
    const discountBar = document.getElementById('DiscountBar');
    const discountFill = document.getElementById('DiscountBarFill');
    const discountText = document.getElementById('DiscountBarText');
    const discountBadge = document.getElementById('DiscountBadge');
    if (discountBar && discountFill && discountText) {
      const count = cart.item_count;
      const pct = Math.min(100, Math.round(count * 100 / DISCOUNT_THRESHOLD));
      discountFill.style.width = pct + '%';
      if (count >= DISCOUNT_THRESHOLD) {
        discountBar.classList.add('discount-bar--unlocked');
        discountText.innerHTML = '✓ Sconto <span>20%</span> attivo sul tuo ordine';
        if (discountBadge) discountBadge.style.display = '';
      } else {
        discountBar.classList.remove('discount-bar--unlocked');
        const missing = DISCOUNT_THRESHOLD - count;
        const word = missing === 1 ? 'articolo' : 'articoli';
        discountText.innerHTML = 'Aggiungi ancora <span>' + missing + ' ' + word + '</span> per il <span>-20%</span>';
        if (discountBadge) discountBadge.style.display = 'none';
      }
    }

    // Shipping bar - re-render with new design
    const threshold = 0;
    const shippingBar = $('#ShippingBar');
    if (shippingBar) {
      if (cart.total_price >= threshold) {
        // Check if already showing unlock (avoid re-triggering animation)
        if (!shippingBar.querySelector('.shipping-unlock')) {
          shippingBar.innerHTML = `
            <div class="shipping-unlock shipping-unlock--animate" id="ShippingUnlock">
              <div class="shipping-unlock__particles" aria-hidden="true">
                <span class="sp sp--1">✦</span><span class="sp sp--2">✦</span>
                <span class="sp sp--3">★</span><span class="sp sp--4">✦</span>
                <span class="sp sp--5">★</span><span class="sp sp--6">✦</span>
              </div>
              <div class="shipping-unlock__inner">
                <span class="shipping-unlock__rocket">🚀</span>
                <div class="shipping-unlock__text">
                  <strong class="shipping-unlock__title">Spedizione gratuita sbloccata!</strong>
                  <span class="shipping-unlock__sub">Il tuo ordine arriva a casa gratis</span>
                </div>
                <span class="shipping-unlock__check">✓</span>
              </div>
            </div>`;
        }
      } else {
        const rem = threshold - cart.total_price;
        const pct = Math.min(100, Math.round(cart.total_price * 100 / threshold));
        shippingBar.innerHTML = `
          <div class="shipping-meter">
            <div class="shipping-meter__header">
              <span class="shipping-meter__label">🚚 Spedizione gratuita</span>
              <span class="shipping-meter__remaining">ancora <strong>${formatMoney(rem)}</strong></span>
            </div>
            <div class="shipping-meter__track">
              <div class="shipping-meter__fill" style="width:${pct}%">
                <span class="shipping-meter__truck" aria-hidden="true">🚚</span>
              </div>
            </div>
          </div>`;
      }
    }

    updateCartBubble(cart.item_count);

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <p class="cart-drawer__empty-icon">🛒</p>
          <p class="cart-drawer__empty-text">Il tuo carrello è vuoto.</p>
          <a href="/collections/all" class="btn btn--primary">Vai allo shop</a>
        </div>`;
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = '';

    const itemsHtml = cart.items.map(item => {
      // Shopify cart API returns URLs like //cdn.shopify.com/.../image.jpg?v=123
      // Use _160x160 (2x retina for 80px display) for sharp images
      let imgSrc = '';
      if (item.image) {
        imgSrc = item.image
          .replace(/(_\d+x\d+)?(\.[a-zA-Z]+)(\?|$)/, '_160x160$2$3')
          .replace(/^\/\//, 'https://');
      }
      return `
      <li class="cart-drawer__item" data-key="${item.key}">
        <a href="${item.url}" class="cart-drawer__item-img-link">
          ${imgSrc ? `<img src="${imgSrc}" alt="${item.title}" width="80" height="80" loading="lazy" class="cart-drawer__item-img" onerror="this.style.display='none'">` : ''}
        </a>
        <div class="cart-drawer__item-info">
          <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : ''}
          <p class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</p>
          <div class="cart-drawer__item-controls">
            <div class="qty-stepper">
              <button type="button" class="qty-stepper__btn" data-action="minus" data-key="${item.key}" aria-label="Meno">−</button>
              <span class="qty-stepper__val">${item.quantity}</span>
              <button type="button" class="qty-stepper__btn" data-action="plus" data-key="${item.key}" aria-label="Più">+</button>
            </div>
            <button type="button" class="cart-drawer__remove" data-key="${item.key}">Rimuovi</button>
          </div>
        </div>
      </li>`;
    }).join('');

    body.innerHTML = `<ul class="cart-drawer__items">${itemsHtml}</ul><div id="CartUpsell"></div>`;
    bindCartDrawerEvents(body);
    renderUpsell(cart);
  }

  async function renderUpsell(cart) {
    const el = document.getElementById('CartUpsell');
    if (!el || cart.item_count === 0) return;

    const firstItem = cart.items[0];
    const cartProductIds = cart.items.map(i => i.product_id);

    try {
      const recRes = await fetch(`/recommendations/products.json?product_id=${firstItem.product_id}&limit=4&intent=related`);
      const recData = await recRes.json();
      const suggestions = recData.products.filter(p => !cartProductIds.includes(p.id)).slice(0, 3);
      if (!suggestions.length) return;

      const html = `
        <div class="cart-upsell">
          <p class="cart-upsell__title">Potrebbe piacerti anche</p>
          <div class="cart-upsell__list">
            ${suggestions.map(p => {
              const img = p.featured_image
                ? p.featured_image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x120$1$2')
                : '';
              const price = (p.price_min / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
              const variantId = p.variants[0].id;
              return `
                <div class="cart-upsell__item">
                  <a href="/products/${p.handle}" class="cart-upsell__img-wrap">
                    ${img ? `<img src="${img}" alt="${p.title}" width="52" height="52" loading="lazy" class="cart-upsell__img">` : ''}
                  </a>
                  <a href="/products/${p.handle}" class="cart-upsell__info">
                    <p class="cart-upsell__name">${p.title.length > 30 ? p.title.slice(0,30)+'…' : p.title}</p>
                    <p class="cart-upsell__price">${price}</p>
                  </a>
                  <button type="button" class="cart-upsell__cta" data-variant-id="${variantId}" aria-label="Aggiungi al carrello">+</button>
                </div>`;
            }).join('')}
          </div>
        </div>`;
      el.innerHTML = html;

      // Bind ATC buttons
      el.querySelectorAll('.cart-upsell__cta').forEach(btn => {
        btn.addEventListener('click', async () => {
          const vid = btn.dataset.variantId;
          btn.classList.add('cart-upsell__cta--loading');
          btn.disabled = true;
          try {
            const r = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: vid, quantity: 1 })
            });
            if (!r.ok) throw new Error();
            const cartRes = await fetch('/cart.js');
            const newCart = await cartRes.json();
            renderCartDrawer(newCart);
          } catch(e) {
            btn.classList.remove('cart-upsell__cta--loading');
            btn.disabled = false;
          }
        });
      });
    } catch(e) {
      // Silently fail
    }
  }

  function bindCartDrawerEvents(container) {
    // Quantity buttons
    $$(`.qty-stepper__btn[data-key]`, container).forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const item = cartDrawer.querySelector(`.cart-drawer__item[data-key="${key}"]`);
        const valEl = item && item.querySelector('.qty-stepper__val');
        let qty = valEl ? parseInt(valEl.textContent, 10) : 1;
        if (btn.dataset.action === 'plus') qty++;
        else qty = Math.max(0, qty - 1);
        await changeCartItem(key, qty);
      });
    });
    // Remove buttons
    $$('.cart-drawer__remove[data-key]', container).forEach(btn => {
      btn.addEventListener('click', () => changeCartItem(btn.dataset.key, 0));
    });
  }

  async function changeCartItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await res.json();
      renderCartDrawer(cart);
    } catch (e) { console.error('Cart change error', e); }
  }

  /* ================================================================
     ADD TO CART (AJAX)
  ================================================================ */
  async function addToCart(variantId, quantity, btn) {
    if (!variantId) return;
    const origHTML = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<svg style="animation:mmSpin .7s linear infinite;vertical-align:middle" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>';
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) || 1 })
      });
      if (!res.ok) throw new Error('Failed');
      await refreshCartDrawer();
      // Brief success state on button before opening drawer
      if (btn) {
        btn.innerHTML = '✓ Aggiunto!';
        btn.style.background = 'var(--accent-dark)';
        btn.style.borderColor = 'var(--accent-dark)';
      }
      setTimeout(() => {
        openCartDrawer();
        showToast('Aggiunto al carrello!');
      }, 400);
    } catch (e) {
      console.error('ATC error', e);
      showToast('Errore — riprova.');
    } finally {
      setTimeout(() => {
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = origHTML;
          btn.style.background = '';
          btn.style.borderColor = '';
        }
      }, 750);
    }
  }

  // Main product form — intercept by class since Shopify generates id="ProductForm-{id}"
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantInput = productForm.querySelector('[name="id"]');
      const variantId = variantInput ? variantInput.value : null;
      const qtyInput = productForm.querySelector('[name="quantity"]') || $('#ProductQty');
      const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      const btn = productForm.querySelector('#AddToCart') || productForm.querySelector('[type="submit"]');
      await addToCart(variantId, qty, btn);
    });
  }

  // Quick add on product cards
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.quick-add-btn');
    if (!btn) return;
    e.preventDefault();
    await addToCart(btn.dataset.variantId, 1, btn);
  });

  // Sticky ATC
  const stickyBtn = $('#StickyAtcBtn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', async () => {
      await addToCart(stickyBtn.dataset.variantId, 1, stickyBtn);
    });
  }

  /* ================================================================
     CART PAGE (full page updates)
  ================================================================ */
  function initCartPage() {
    const cartItems = $('.cart-items');
    if (!cartItems) return;

    cartItems.addEventListener('click', (e) => {
      const qBtn = e.target.closest('.cart-qty-btn');
      if (qBtn) {
        const key = qBtn.dataset.key;
        const input = cartItems.querySelector(`.cart-qty-input[data-key="${key}"]`);
        if (!input) return;
        let val = parseInt(input.value, 10);
        if (qBtn.dataset.action === 'plus') val++;
        else val = Math.max(0, val - 1);
        input.value = val;
        updateCartPage(key, val);
      }
      const removeBtn = e.target.closest('.cart-remove-btn');
      if (removeBtn) updateCartPage(removeBtn.dataset.key, 0);
    });

    cartItems.addEventListener('change', (e) => {
      const input = e.target.closest('.cart-qty-input');
      if (input) updateCartPage(input.dataset.key, parseInt(input.value, 10));
    });
  }

  async function updateCartPage(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      window.location.reload();
    } catch (e) { console.error(e); }
  }

  /* ================================================================
     VARIANT SELECTOR (product page)
  ================================================================ */
  function initVariantSelector() {
    const product = window.productJSON;
    if (!product) return;

    let selectedOptions = (product.variants[0] ? product.variants[0].options : []).slice();

    function findVariant() {
      return product.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
    }

    function updateUI(v) {
      if (!v) return;
      // Price
      const priceEl = $('#ProductPrice');
      if (priceEl) {
        if (v.compare_at_price > v.price) {
          const pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          priceEl.innerHTML = `<span class="price price--sale">${formatMoney(v.price)}</span>
            <s class="price price--compare">${formatMoney(v.compare_at_price)}</s>
            <span class="badge-sale">-${pct}%</span>`;
        } else {
          priceEl.innerHTML = `<span class="price">${formatMoney(v.price)}</span>`;
        }
      }
      // Hidden input
      const vid = $('#VariantId');
      if (vid) vid.value = v.id;
      // ATC button
      const atc = $('#AddToCart');
      const atcText = $('#AddToCartText');
      if (atc) {
        atc.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? (atc.dataset.addText || '🛒 Aggiungi al carrello') : 'Esaurito';
      }
      // Sticky ATC
      const sticky = $('#StickyAtcBtn');
      const stickyPrice = $('#StickyPrice');
      if (sticky) { sticky.dataset.variantId = v.id; sticky.disabled = !v.available; }
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      // URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }

    $$('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.optionIdx, 10);
        const val = btn.dataset.optionVal;
        selectedOptions[idx] = val;

        // Update selected states
        $$('.variant-btn').forEach(b => {
          if (parseInt(b.dataset.optionIdx, 10) === idx) {
            b.classList.toggle('is-selected', b.dataset.optionVal === val);
          }
        });

        // Update label
        const selLabel = $(`#OptionSelected${idx}`);
        if (selLabel) selLabel.textContent = val;

        const variant = findVariant();
        if (variant) updateUI(variant);
      });
    });
  }

  /* ================================================================
     PRODUCT GALLERY
  ================================================================ */
  function initGallery() {
    const main = $('#GalleryMain');
    const thumbsWrap = $('#GalleryThumbs');
    if (!main) return;
    const slides = $$('.gallery-slide', main);
    const thumbs = thumbsWrap ? $$('.gallery-thumb', thumbsWrap) : [];

    function goTo(idx) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
  }

  /* ================================================================
     QUANTITY INPUTS (generic, non-cart)
  ================================================================ */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty-stepper__btn[data-target]');
    if (!btn) return;
    const target = document.getElementById(btn.dataset.target);
    if (!target) return;
    let val = parseInt(target.value, 10) || 1;
    if (btn.dataset.action === 'plus') val++;
    else if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
    target.value = val;
  });

  /* ================================================================
     STICKY ATC (product page)
  ================================================================ */
  function initStickyAtc() {
    const sticky = $('#StickyAtc');
    const form = $('#AddToCart');
    if (!sticky || !form) return;
    const obs = new IntersectionObserver(entries => {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 });
    obs.observe(form);
  }

  /* ================================================================
     MOBILE NAV
  ================================================================ */
  const mobileNav = $('#MobileNav');
  const hamburger = $('#HamburgerBtn');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.removeAttribute('aria-hidden');
    hamburger && hamburger.classList.add('is-open');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-open');
    showOverlay();
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    hamburger && hamburger.classList.remove('is-open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
    hideOverlay();
  }

  hamburger && hamburger.addEventListener('click', () => {
    if (mobileNav && mobileNav.classList.contains('is-open')) closeMobileNav();
    else openMobileNav();
  });

  const mobileClose = $('#MobileNavClose');
  mobileClose && mobileClose.addEventListener('click', closeMobileNav);

  /* ================================================================
     SEARCH TOGGLE
  ================================================================ */
  const searchBar = $('#SearchBar');
  const searchToggle = $('#SearchToggle');
  const searchClose = $('#SearchClose');
  const searchInput = $('#SearchInput');

  function openSearch() {
    if (!searchBar) return;
    searchBar.classList.add('is-open');
    searchBar.removeAttribute('aria-hidden');
    searchToggle && searchToggle.setAttribute('aria-expanded', 'true');
    setTimeout(() => searchInput && searchInput.focus(), 50);
  }
  function closeSearch() {
    if (!searchBar) return;
    searchBar.classList.remove('is-open');
    searchBar.setAttribute('aria-hidden', 'true');
    searchToggle && searchToggle.setAttribute('aria-expanded', 'false');
  }

  searchToggle && searchToggle.addEventListener('click', () => {
    if (searchBar && searchBar.classList.contains('is-open')) closeSearch();
    else openSearch();
  });
  searchClose && searchClose.addEventListener('click', closeSearch);

  /* ================================================================
     DOM READY
  ================================================================ */
  document.addEventListener('DOMContentLoaded', () => {
    initGallery();
    initVariantSelector();
    initStickyAtc();
    initCartPage();
    // Bind SSR-rendered cart drawer items
    const drawerBody = $('#CartDrawerBody');
    if (drawerBody) bindCartDrawerEvents(drawerBody);
  });

})();

/* ================================================================
   CAROUSEL (featured collection)
================================================================ */
(function initCarousels() {
  function setupCarousel(carousel) {
    const id = carousel.dataset.id;
    const track = document.getElementById('FcTrack-' + id);
    const dotsWrap = document.getElementById('FcDots-' + id);
    if (!track) return;

    const slides = [...track.querySelectorAll('.fc-carousel__slide')];
    if (!slides.length) return;

    // Calculate visible slides
    function getVisibleCount() {
      const w = carousel.offsetWidth;
      if (w >= 900) return 4;
      if (w >= 600) return 2;
      return 1;
    }

    // Create dots
    function buildDots() {
      if (!dotsWrap) return;
      const count = Math.ceil(slides.length / getVisibleCount());
      dotsWrap.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.className = 'fc-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Pagina ' + (i + 1));
        dot.addEventListener('click', () => goToPage(i));
        dotsWrap.appendChild(dot);
      }
    }

    function updateDots(page) {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.fc-dot').forEach((d, i) => d.classList.toggle('is-active', i === page));
    }

    function getCurrentPage() {
      const vc = getVisibleCount();
      const slideW = slides[0].offsetWidth + 20; // gap
      return Math.round(track.scrollLeft / (slideW * vc));
    }

    function goToPage(page) {
      const vc = getVisibleCount();
      const slideW = slides[0].offsetWidth + 20;
      track.scrollTo({ left: slideW * vc * page, behavior: 'smooth' });
      updateDots(page);
    }

    // Nav buttons
    carousel.querySelectorAll('.fc-carousel__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const dir = btn.dataset.dir === 'next' ? 1 : -1;
        const page = getCurrentPage() + dir;
        const maxPage = Math.ceil(slides.length / getVisibleCount()) - 1;
        goToPage(Math.max(0, Math.min(page, maxPage)));
      });
    });

    // Scroll → update dots
    let scrollTimer;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => updateDots(getCurrentPage()), 80);
    }, { passive: true });

    buildDots();
    window.addEventListener('resize', () => { buildDots(); }, { passive: true });
  }

  // Init on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.fc-carousel').forEach(setupCarousel);
  });
})();

// ================================================================
// SCROLL ANIMATIONS
// ================================================================
(function () {
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px 0px 0px' });

  function initAnimations() {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }
})();


// Hero animation — safe: add class first, then animate
(function() {
  function animateHero() {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    // Step 1: add class that enables the hidden state
    hero.classList.add('hero-animate-ready');
    // Step 2: on next frame, trigger visible
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        document.querySelectorAll('.hero__eyebrow[data-animate], .hero__title[data-animate], .hero__subtitle[data-animate], .hero__ctas[data-animate]').forEach(function(el) {
          el.classList.add('is-visible');
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', animateHero);
  } else {
    animateHero();
  }
})();

// ================================================================
// STICKY HEADER
// ================================================================
(function () {
  var wrapper = document.getElementById('SiteHeaderWrapper');
  var header  = document.getElementById('SiteHeader');
  if (!wrapper || !header) return;

  var mode = header.getAttribute('data-sticky') || 'scroll-up';
  if (!mode) mode = 'scroll-up';

  if (mode === 'none') {
    wrapper.style.position = 'relative';
    return;
  }
  if (mode === 'always') return; // sticky via CSS, no hide/show logic needed

  // scroll-up: hide wrapper on scroll down, show on scroll up
  var lastY = window.scrollY;
  var ticking = false;
  var THRESHOLD = 80;

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        var currentY = window.scrollY;
        if (currentY < THRESHOLD) {
          wrapper.classList.remove('site-header--hidden');
        } else if (currentY > lastY) {
          wrapper.classList.add('site-header--hidden');
        } else {
          wrapper.classList.remove('site-header--hidden');
        }
        lastY = currentY;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

// ================================================================
// LANGUAGE SWITCHER
// ================================================================
(function () {
  function initLangSwitcher(btn, dropdown) {
    if (!btn || !dropdown) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = dropdown.classList.contains('is-open');
      dropdown.classList.toggle('is-open', !open);
      btn.setAttribute('aria-expanded', String(!open));
      dropdown.setAttribute('aria-hidden', String(open));
    });
    document.addEventListener('click', function () {
      dropdown.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      dropdown.setAttribute('aria-hidden', 'true');
    });
  }

  // Desktop
  var desktopSwitcher = document.querySelector('.lang-switcher--desktop');
  if (desktopSwitcher) {
    initLangSwitcher(
      desktopSwitcher.querySelector('.lang-switcher__btn'),
      document.getElementById('LangDropdown')
    );
  }

  // Mobile
  var mobileSwitcher = document.querySelector('.lang-switcher--mobile');
  if (mobileSwitcher) {
    initLangSwitcher(
      mobileSwitcher.querySelector('.lang-switcher__btn'),
      document.getElementById('LangDropdownMobile')
    );
  }
})();

// ================================================================
// ANNOUNCEMENT BAR SLIDESHOW
// ================================================================
(function () {
  function initAnnouncement() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;
    var slides = Array.prototype.slice.call(bar.querySelectorAll('.announcement-bar__slide'));
    if (slides.length <= 1) return;

    var current = 0;
    var duration = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
    var timer = null;

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(function() { goTo(current + 1); }, duration);
    }

    var prevBtn = bar.querySelector('.announcement-bar__prev');
    var nextBtn = bar.querySelector('.announcement-bar__next');

    prevBtn && prevBtn.addEventListener('click', function() {
      goTo(current - 1); startTimer();
    });
    nextBtn && nextBtn.addEventListener('click', function() {
      goTo(current + 1); startTimer();
    });

    bar.addEventListener('mouseenter', function() { clearInterval(timer); });
    bar.addEventListener('mouseleave', startTimer);

    startTimer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncement);
  } else {
    initAnnouncement();
  }
})();
